// ManageBilling.tsx
import React, { useState } from "react";
import { subscriptionAPI } from "../utils/API"; // adjust path as needed
import "../styles/ManageBilling.css"; // ⬅️ make sure this path is correct

interface ManageBillingProps {
  email: string;
}

export const ManageBilling: React.FC<ManageBillingProps> = ({ email }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleManageBilling = async () => {
    if (!email) {
      setError("No email found for this account.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const { url } = await subscriptionAPI.createBillingPortalSession(email);
      window.location.href = url; // redirect to Stripe billing portal
    } catch (err: any) {
      setError(err.message || "Something went wrong while opening billing.");
      setLoading(false);
    }
  };

  return (
    <section className="billing-section manage-billing">
      <div className="billing-card manage-billing__card">
        <header className="billing-card__header">
          <h2 className="billing-card__title">Manage Subscription</h2>
          <p className="billing-card__subtitle">
            Manage your plan, payment details, and invoices in a secure Stripe billing portal.
          </p>
        </header>

        <div className="billing-card__body manage-billing__body">
          <div className="billing-card__info manage-billing__info">
            <p className="billing-card__label">Billing account</p>
            <p className="billing-card__value manage-billing__email-pill">{email}</p>
          </div>

          {error && <p className="billing-card__error manage-billing__error">{error}</p>}
        </div>

        <footer className="billing-card__footer manage-billing__footer">
          <div className="manage-billing__actions">
            <button
              type="button"
              className="billing-button billing-button--primary manage-billing__button"
              onClick={handleManageBilling}
              disabled={loading}
            >
              {loading ? "Opening billing portal..." : "Open Stripe Billing Portal"}
            </button>
          </div>

          <p className="billing-card__helper manage-billing__helper">
            You&apos;ll be redirected to a secure Stripe page where you can update payment methods,
            download invoices, or cancel your subscription.
          </p>
        </footer>
      </div>
    </section>
  );
};
